/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React from "react";
import { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { intl } from "../services/intlGlobalProvider";
import * as _ from "underscore";
import Color from "../utils/Color";
import Toast from "../utils/Toast";

const StyledContainer = styled.div`
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  color: ${props => (props.isChecked ? Color.darkGreenTextColor : "gray")};
  justify-content: center;
  align-items: center;
`;

const StyledRoundedContainer = styled.div`
  background: ${props =>
    props.isChecked ? Color.darkGreenTextColor : "white"};
  border-radius: 50%;
  border: 1px solid
    ${props => (props.isChecked ? Color.darkGreenTextColor : "gray")};
  width: 0.4em;
  height: 0.4em;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledTitle = styled.span`
  margin-left: 3px;
  font-size: 0.9em;
`;

class DeliveryCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false
    };
  }

  componentDidMount() {
    const { isChecked } = this.props;

    this.setState({
      isChecked: isChecked
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.isChecked !== nextProps.isChecked ||
      this.state.isChecked !== nextProps.isChecked
    ) {
      this.setState({
        isChecked: nextProps.isChecked
      });
    }
  }

  onClicked = e => {
    const { onClicked, disabled } = this.props;

    e.stopPropagation();
    if (disabled) {
      Toast.warning(
        intl.formatMessage({
          id: "product.selection.take.away.not.allow",
          defaultMessage: "Take Away is not allow!"
        })
      );
      return;
    }

    this.setState({
      isChecked: !this.state.isChecked
    });

    if (onClicked) {
      onClicked(!this.state.isChecked);
    }
  };

  render() {
    const { isChecked } = this.state;
    const { style, price } = this.props;

    return (
      <StyledContainer
        isChecked={isChecked}
        style={style}
        onClick={e => {
          this.onClicked(e);
        }}
      >
        <StyledRoundedContainer isChecked={isChecked} />
        <StyledTitleContainer>
          <StyledTitle>
            <FormattedMessage
              id="product.selection.take.away.option"
              defaultMessage="Take Away"
            />
          </StyledTitle>
          {!_.isEmpty(price) ? <StyledTitle>{price}</StyledTitle> : false}
        </StyledTitleContainer>
      </StyledContainer>
    );
  }
}

DeliveryCheckbox.propTypes = {
  onClicked: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  price: PropTypes.string
};

DeliveryCheckbox.defaultProps = {
  isChecked: false
};

export default DeliveryCheckbox;



// WEBPACK FOOTER //
// ./src/components/DeliveryCheckbox.js